module.exports = __webpack_public_path__ + "img/appdesign.a2f29e80.svg";